import { User } from '@/types';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/atoms/ui/card';
import { SkeletonCards } from '@/components/organisms/Loading';
import { formatTimestamp } from '@/lib/utils';
import { UserAvatar } from '@/components/atoms/UserAvatar';

interface UserListComponentProps {
  users: User[];
  loading?: boolean;
  onUserClick: (username: string) => void;
}

export const UserListComponent: React.FC<UserListComponentProps> = ({
  users,
  loading,
  onUserClick,
}) => {
  if (loading) {
    return <SkeletonCards count={6} />;
  }

  if (users.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">No users found</p>
      </div>
    );
  }

  return (
    <div className="user-list-component grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {users.map((user) => (
        <Card
          key={user.uid}
          className="cursor-pointer transition-all hover:shadow-lg"
          onClick={() => onUserClick(user.username)}
        >
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <UserAvatar photoURL={null} username={user.username} size="md" />
              <span>{user.username}</span>
            </CardTitle>
            <CardDescription>{user.email}</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>
                {user.boards.length} board{user.boards.length !== 1 ? 's' : ''}
              </p>
              <p>Joined {formatTimestamp(user.createdAt.toDate())}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

